import { createContext, useContext } from 'react'
import { type User, type Company } from '../services'

// Define Role type based on the API schema
export type Role = 'SUPERADMIN' | 'ADMIN' | 'EMPLOYEE'
type Ctx = {
  user?: User
  company?: Company
  isLoading: boolean
  /** Admin login – returns MFA challenge info when MFA is required */
  login: (
    e: string,
    p: string
  ) => Promise<{ mfaRequired: true } | { mfaRequired: false; role?: Role }>
  /** Complete MFA verification after admin login */
  mfaVerify: (challengeId: string, code: string) => Promise<Role | undefined>
  /** Request OTP for employee login via phone */
  sendOtp: (phone: string) => Promise<void>
  /** Verify OTP and complete employee login */
  verifyOtp: (phone: string, code: string) => Promise<void>
  logout: () => void
}

export const AuthCtx = createContext<Ctx>({} as any)

export const useAuth = () => useContext(AuthCtx)
